import {
  IP_LIST_REQUEST,
  IP_LIST_RESPONSE,
  IP_ITEMS_ADDED,
  IP_ITEMS_REMOVED,
  IP_MEMO_CHANGED,
} from '../actions/ipManagement.actions';

export default function ipManagement(
  state = {
    pcSlots: [],
    dirty: false,
    fetched: false,
  },
  action
) {
  switch (action.type) {
    case IP_LIST_REQUEST: {
      return {
        pcSlots: [],
        dirty: false,
        fetched: false,
      };
    }
    case IP_LIST_RESPONSE: {
      let nextState = {
        ...state,
        pcSlots: action.pcSlots,
        dirty: false,
        fetched: true,
      };
      return nextState;
    }
    case IP_ITEMS_ADDED: {
      let nextPcSlots = Object.assign([], state.pcSlots);
      nextPcSlots = nextPcSlots.concat(
        action.pcSlots.filter(
          pcSlot =>
            nextPcSlots.map(nextPcSlot => nextPcSlot.identificationValue).includes(pcSlot.identificationValue) === false
        )
      );

      let nextState = {
        ...state,
        pcSlots: nextPcSlots,
        dirty: true,
      };

      return nextState;
    }
    case IP_ITEMS_REMOVED: {
      let nextPcSlots = state.pcSlots.filter(pcSlot => !action.pcSlots.includes(pcSlot.identificationValue));
      let nextState = {
        ...state,
        pcSlots: nextPcSlots,
        dirty: true,
      };

      return nextState;
    }
    case IP_MEMO_CHANGED: {
      let nextState = Object.assign({}, state);
      let pcSlotToBeChanged = nextState.pcSlots.find(
        pcSlot => pcSlot.identificationValue === action.identificationValue
      );
      pcSlotToBeChanged.memo = action.memo;

      nextState.dirty = true;
      return nextState;
    }
  }
  return state;
}
